import { Button, Card, Empty, Tooltip, Typography } from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import AddClosedPeriod from "../../../../../Modal/AddClosedPeriod";
import { useEffect, useState } from "react";
import ConfirmationModal from "../../../../../Modal/ConfirmationModal";
import { changeLoader } from "../../../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../../../../utils/global/globalRequest";
import * as Apis from "../../../../../utils/helper/enum";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { formatDateFunction, formatDateFunctionNew } from "../../../../../utils/helper/utils";

const DriverHoliday = () => {
  const dispatch = useDispatch();
  let { id } = useParams();

  const [item, setItem] = useState(null);
  const [items, setItems] = useState([]);
  const [addHolidayModalOpen, setAddHolidayModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const showAddHolidayModal = () => {
    setAddHolidayModalOpen(true);
  };

  const handleAddHolidaysOk = () => {
    setAddHolidayModalOpen(false);
    setItem(null);
    if (id) {
      getDriverHolidays(id);
    }
  };

  const handleAddHolidaysCancel = () => {
    setItem(null);
    setAddHolidayModalOpen(false);
  };

  const getDriverHolidays = async (driverId) => {
    try {
      let response = await globalRequest(
        Apis.DRIVER_HOLIDAY.GET_ALL_HOLIDAY + "/" + driverId,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setItems(apiResponse?.data?.data || apiResponse?.data || []);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const addEditHoliday = async (formData) => {
    let sd = formatDateFunction(new Date(formData?.start_date), "yyyy-mm-dd");
    let ed = formatDateFunction(new Date(formData?.end_date), "yyyy-mm-dd");

    let insertData = {
      driverId: Number(id),
      start_date: sd,
      end_date: ed,
      description: formData?.description,
    };

    dispatch(changeLoader(true));
    try {
      let url = Apis?.DRIVER_HOLIDAY?.CREATE_HOLIDAY;
      let method = "post";
      if (formData.id > 0) {
        url = Apis?.DRIVER_HOLIDAY?.EDIT_HOLIDAY + "/" + formData.id;
        method = "put";
      }
      let response = await globalRequest(url, method, insertData, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Holiday created successfully";
        if (formData.id) msg = "Holiday updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getDriverHolidays(id);
        setAddHolidayModalOpen(false);
        setItem(null);
      } else {
        toast.error(apiResponse?.message || "Something went wrong");
      }
    } catch (e) {
      toast.error(e?.message || "Something went wrong");
    }
    dispatch(changeLoader(false));
  };

  const handleDeleteHoliday = (holiday) => {
    setItem(holiday);
    setIsDeleteModalOpen(true);
  };

  const handleDeleteOk = async () => {
    try {
      dispatch(changeLoader(true));
      let response = await globalRequest(
        Apis.DRIVER_HOLIDAY.DELETE_HOLIDAY + "/" + item?.id,
        "put",
        { status: "deleted" },
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        toast.success("Holiday deleted successfully");
        setIsDeleteModalOpen(false);
        if (id) {
          getDriverHolidays(id);
        }
      } else {
        toast.error(apiResponse?.message || response?.data?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    } finally {
      dispatch(changeLoader(false));
    }
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
    setItem(null);
  };

  useEffect(() => {
    if (id) {
      getDriverHolidays(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleEditClick = (holiday) => {
    setItem(holiday);
    setAddHolidayModalOpen(true);
  };

  return (
    <div className="min-h-[calc(100vh_-_305px)]">
      <div className="flex justify-between items-center mb-6">
        <Typography.Title level={4} className="m-0">
          Holidays
        </Typography.Title>
        <Button
          type="primary"
          size="large"
          icon={<PlusOutlined />}
          onClick={showAddHolidayModal}
          className="rounded-lg"
        >
          Add Holiday
        </Button>
      </div>

      {items?.length > 0 ? (
        <div className="space-y-4">
          {items?.map((holiday) => (
            <Card
              key={holiday?.id}
              size="small"
              className="hover:shadow-md transition-shadow"
              extra={
                <div className="flex gap-2">
                  <Tooltip title="Edit">
                    <EditOutlined
                      className="cursor-pointer text-blue-500"
                      onClick={() => handleEditClick(holiday)}
                    />
                  </Tooltip>
                  <Tooltip title="Delete">
                    <DeleteOutlined
                      className="cursor-pointer text-red-500"
                      onClick={() => handleDeleteHoliday(holiday)}
                    />
                  </Tooltip>
                </div>
              }
            >
              <div>
                <p className="font-semibold">{holiday?.description}</p>
                <p className="text-sm text-gray-600">
                  {formatDateFunctionNew(holiday?.startDate)} -{" "}
                  {formatDateFunctionNew(holiday?.endDate)}
                </p>
              </div>
            </Card>
          ))}
        </div>
      ) : (
        <Empty description="No holidays added" />
      )}

      {addHolidayModalOpen && (
        <AddClosedPeriod
          isOpen={addHolidayModalOpen}
          onOk={handleAddHolidaysOk}
          onCancel={handleAddHolidaysCancel}
          data={item || null}
          onSubmit={addEditHoliday}
        />
      )}

      {isDeleteModalOpen && (
        <ConfirmationModal
          ConfirmationHeading="Delete"
          ConfirmationParagraph="Are you sure you want to delete this holiday?"
          isOpen={isDeleteModalOpen}
          onOk={handleDeleteOk}
          onCancel={handleDeleteCancel}
        />
      )}
    </div>
  );
};

export default DriverHoliday;
